import React from 'react';
import Cldr from 'utils/Cldr';
import clsx from '@strava/ui/clsx';
import I18n from 'utils/I18n';
import { trackV2 } from 'utils/analytics';
import Radio from '@strava/ui/Radio';

import {
  setMonthlyDuration,
  setYearlyDuration
} from '../../../state/Checkout.actions';
import { useCheckoutContext } from '../../../state/CheckoutContext';

import styles from './DurationSelect.scss';

export const I18nPrefix = 'strava.subscriptions.checkout.summary.trial';

export const DurationSelect = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const {
    analyticsData,
    checkoutSubmitting,
    currency,
    duration,
    products,
    promoCodeSubmitting,
    trialInfo,
    yearlyPercentOff
  } = checkoutEntityState;
  const yearlyRecurringAmount = products?.yearly?.recurringAmount;
  const monthlyRecurringAmount = products?.monthly?.recurringAmount;
  const disabled =
    checkoutSubmitting || promoCodeSubmitting || products?.promotion?.full;
  const trialLength = trialInfo?.trialLength;

  const handleDurationChange = ({ durationSelected, onClickFunc }) => {
    trackV2({
      category: 'summit_upsell',
      page: 'cart',
      action: 'change_duration',
      properties: {
        ...analyticsData,
        duration: durationSelected,
        subscription_type: 'trial'
      }
    });

    dispatch(onClickFunc());
  };

  return (
    <div className={styles.durationSelect}>
      <label className={styles.durationOption} htmlFor="duration-yearly">
        <Radio
          id="duration-yearly"
          type="radio"
          name="duration"
          className={styles.radioButton}
          checked={duration === 'yearly'}
          disabled={disabled}
          onChange={() =>
            handleDurationChange({
              durationSelected: 'yearly',
              onClickFunc: setYearlyDuration
            })
          }
          value="yearly"
        />
        <div className={clsx(styles.optionLabel, styles.borderBottom)}>
          <div className={styles.optionLabelTop}>
            {I18n.t(`${I18nPrefix}.yearly`)}
            <span className={styles.yearlyPercentOff}>
              {I18n.t(`${I18nPrefix}.savings`, {
                percent: Math.round(yearlyPercentOff)
              })}
            </span>
          </div>
          <div className={styles.optionLabelBottom}>
            {I18n.t(`${I18nPrefix}.recurring_cost.yearly`, {
              days: trialLength,
              price: Cldr.formatCurrency(yearlyRecurringAmount, currency)
            })}
          </div>
        </div>
      </label>
      <label className={styles.durationOption} htmlFor="duration-monthly">
        <Radio
          id="duration-monthly"
          type="radio"
          name="duration"
          className={styles.radioButton}
          checked={duration === 'monthly'}
          disabled={disabled}
          onChange={() =>
            handleDurationChange({
              durationSelected: 'monthly',
              onClickFunc: setMonthlyDuration
            })
          }
          value="monthly"
        />
        <div className={styles.optionLabel}>
          <div className={styles.optionLabelTop}>
            {I18n.t(`${I18nPrefix}.monthly`)}
          </div>
          <div className={styles.optionLabelBottom}>
            {I18n.t(`${I18nPrefix}.recurring_cost.monthly`, {
              days: trialLength,
              price: Cldr.formatCurrency(monthlyRecurringAmount, currency)
            })}
          </div>
        </div>
      </label>
    </div>
  );
};

export default DurationSelect;
